export default __webpack_public_path__ + "static/media/gallery-13-1.b164cec2.webp";